import {isApplePayAvailable} from 'libs/checkout/checkout';

export const PAYMENT_METHODS = {
    APPLEPAY: 'stripe_apple_pay',
    GOOGLEPAY: 'stripe_google_pay',
    APPLEPAY_OLD: 'optimax_applepay',
    AMAZON: 'amazon_payments',
    ZOOZ: 'payments',
    PAYMENT_OS: 'ms_paymentsos',
    GIFT: 'ugiftcert',
    RECURLY: 'recurly',
    KLARNA: 'klarna',
    STRIPE: 'stripe',
    CASH_ON_DELIVERY: 'cashondelivery',
    CHECKMO: 'checkmo',
    FREE: 'free',
};

export const STANDARD_PAYMENT_METHODS = [
    PAYMENT_METHODS.CASH_ON_DELIVERY,
    PAYMENT_METHODS.CHECKMO,
    PAYMENT_METHODS.GIFT,
    PAYMENT_METHODS.FREE,
];

export const PAYMENT_METHODS_INSTANT = [PAYMENT_METHODS.APPLEPAY];

export const PAYMENT_METHODS_UNAVAILABILITY = {
    [PAYMENT_METHODS.APPLEPAY]: () => !isApplePayAvailable(),
};

export const DEFAULT_PAYMENT_METHODS = [PAYMENT_METHODS.PAYMENT_OS, PAYMENT_METHODS.GIFT];

export const PAYMENTOS_IFRAME_ID = 'card-secure-fields';

export const PAYMENT_CODE_MESSAGE: {[key: string]: string} = {
    amazon_payments: 'Amazon pay',
    ms_paymentsos: 'Credit Card',
    optimax_applepay: 'Apple pay',
    ugiftcert: 'Gift certificate',
    klarna: 'Klarna',
    recurly: 'Recurly',
    stripe_apple_pay: 'Apple pay',
};

export const PAYMENT_OS_ERRORS = {
    PAN: 'Please enter a valid credit card number',
    EXPIRY: 'Please enter a valid expiration date',
    CVV: "Please enter your card's security code (CVV/CID)",
    NOT_VALID_CVV: 'Please enter a valid security code (CVV/CID)',
};
